import { PageLayout, Content } from "aldoo-ra/Layouts"
import Navbar from "../Navbar"
import Footer from "../Footer"

export default function Site({ children }) {
  return (
    <PageLayout>
      <Navbar />
      <Content>{children}</Content>
      <Footer />
    </PageLayout>
  )
}